import { Injectable } from '@angular/core';
import { BaseService } from '../../abstracts/base.service';
import { ResultModel } from '../../models/result.model';

@Injectable({
  providedIn: 'root'
})
export class CalendarService extends BaseService {

  listAll() {
    return this.httpClient.get<ResultModel<any[]>>(this.getApiUrl('calendar/list/'));
  }

  listAllTrainings(instructorID, trainingID, companyID) {
    var queryParams = {
      pTrainingID: trainingID,
      pInstructorID: instructorID,
      pCompanyID: companyID,
    };
    return this.httpClient.get<ResultModel<any[]>>(this.getApiUrl('calendar/trainings?' + this.getQueryString(queryParams)));
  }

  listAllActivities(instructorID, companyID) {
    var queryParams = {
      pCompanyID: companyID,
      pInstructorID: instructorID
    };
    return this.httpClient.get<ResultModel<any[]>>(this.getApiUrl('calendar/activities?' + this.getQueryString(queryParams)));
  }

  listAllCalender(instructorID, trainingID, companyID, activityType) {
    var queryParams = {
      pTrainingID: trainingID,
      pCompanyID: companyID,
      pInstructorID: instructorID,
      pActivityType: activityType
    };
    return this.httpClient.get<{dataTraining:any[],dataActivity:any[]}>(this.getApiUrl('calendar/all?' + this.getQueryString(queryParams)));
  }

}
